import React from 'react';
import PropTypes from 'prop-types';

import TextField from '../../TextField';

import s from './OpenQuestion.css';

export default function OpenQuestion(props) {
  const {total, count, question, onChange, totalPage, currPage} = props;
  const [q] = question;

  return (
    <div className={s.OpenQuestion}>
      <div className={s.QuestionContainer}>
        <div className={s.Counter}>
          <sup>{currPage}</sup>
          <span>/</span>
          <sub>{totalPage}</sub>
        </div>

        <div className={s.Text}>
          <label>{q.text} </label>
        </div>
      </div>

      <div className={s.AnswerContainer}>
        <TextField
          id="open-question"
          className={s.TextField}
          placeholder="Ora tocca a te"
          text={q.textValue || ''}
          multiline
          autofocus
          onChange={ev => onChange({questionId: q.id, value: ev.target.value})}
        />
      </div>
    </div>
  );
}

OpenQuestion.propTypes = {
  total: PropTypes.number,
  count: PropTypes.number,
  question: PropTypes.array,
  onChange: PropTypes.func,
  totalPage: PropTypes.number,
  currPage: PropTypes.number,
};
